import { StaticBaseDao } from '@/dao';
import {
    RaceContestantWithTimesRequest,
    RaceContestantWithTimes,
    RaceContestantWithPointsRequest,
    RaceContestantWithPoints,
} from '@/objects/generated';

export class QuickInputDao extends StaticBaseDao {
    public static async GetByBibWithTimes(eventID: number, req: RaceContestantWithTimesRequest): Promise<RaceContestantWithTimes[]> {
        return this.BaseFetchArray(
            RaceContestantWithTimes,
            `QuickInput/GetByBibWithTimes` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            req,
        );
    }
    public static async GetByBibWithPoints(eventID: number, req: RaceContestantWithPointsRequest): Promise<RaceContestantWithPoints[]> {
        return this.BaseFetchArray(
            RaceContestantWithPoints,
            `QuickInput/GetByBibWithPoints` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            req,
        );
    }
}
